<template>
  <div class="legal-container">
    <div
      class="flex flex-row items-center p-4 rounded-2xl bg-cool-200 dark:bg-[#1B2022]"
    >
      <div class="flex flex-grow pl-2">
        <Logo variant="full" />
      </div>

      <div class="flex flex-row items-center gap-2" v-if="userStore.loggedIn">
        <NuxtLink :to="{ name: 'settings' }" class="button primary">
          My Account
        </NuxtLink>
      </div>
      <div class="flex flex-row items-center gap-2" v-else>
        <Button @click="showJoinModal">Sign Up</Button>
        <Button theme="outline" @click="showLoginModal">Login</Button>
      </div>
    </div>

    <div class="flex flex-col gap-8 px-4 sm:px-16">
      <div class="flex flex-row flex-wrap gap-6 border-b border-cool-500 pb-8">
        <NuxtLink to="/privacy">Privacy Policy</NuxtLink>
        <NuxtLink to="/cookie-notice">Cookie Notice</NuxtLink>
        <NuxtLink to="/anti-spam-policy">Anti-Spam Policy</NuxtLink>
        <NuxtLink to="/general-terms-of-service">
          General Terms of Service
        </NuxtLink>
        <NuxtLink to="/terms-for-creators">Terms for Creators</NuxtLink>
        <NuxtLink to="/terms-for-users">Terms for Users</NuxtLink>
        <NuxtLink to="/community-standards">Community Standards</NuxtLink>
        <NuxtLink to="/billing-support">Billing Support</NuxtLink>
        <NuxtLink to="/2257">18 U.S.C. § 2257</NuxtLink>
        <NuxtLink to="/dmca">DMCA</NuxtLink>
        <NuxtLink to="/content-removal">Content Removal</NuxtLink>
        <NuxtLink to="/california-privacy-notice">CA Privacy Notice</NuxtLink>
      </div>

      <div
        class="flex flex-row items-center gap-4 font-medium text-lg leading-none"
      >
        <span class="text-primary-600">Legal Information</span>
        <span>/</span>
        <span>{{ title }}</span>
      </div>

      <div class="flex flex-row gap-8">
        <div class="w-3/12 hidden flex-col gap-8 sm:flex">
          <span class="text-lg font-bold leading-normal">{{ title }}</span>
          <slot name="sidebar" />
        </div>
        <div class="w-full flex flex-col gap-8">
          <slot />
        </div>
      </div>
    </div>

    <div
      class="flex flex-col gap-4 items-center text-[13px] py-12 mt-12 border-t border-cool-500 sm:flex-row"
    >
      <div>
        &copy; {{ new Date().getFullYear() }} Favoritely. All rights reserved.
      </div>
      <div class="flex flex-grow">
        <Logo variant="full" class="mx-auto" />
      </div>
      <div>
        <div class="flex flex-row gap-2 text-xs text-gray-400">
          <font-awesome-icon
            icon="fa-brands fa-instagram"
            class="rounded-full p-3 text-gray-400 border border-gray-300 dark:border-gray-800"
          />
          <font-awesome-icon
            icon="fa-brands fa-x-twitter"
            class="rounded-full p-3 text-gray-400 border border-gray-300 dark:border-gray-800"
          />
        </div>
      </div>
    </div>
  </div>

  <UModal
    v-model="loginShowing"
    :ui="{ container: 'items-start md:items-center' }"
  >
    <div class="p-8 pb-16">
      <LoginForm @logged-in="loginShowing = false" />
    </div>
  </UModal>

  <UModal
    v-model="joinShowing"
    :ui="{ container: 'items-start md:items-center' }"
  >
    <div class="p-8 pb-16">
      <JoinForm @logged-in="joinShowing = false" />
    </div>
  </UModal>

  <UNotifications>
    <template #title="{ title }">
      <span v-html="title" />
    </template>

    <template #description="{ description }">
      <span v-html="description" />
    </template>
  </UNotifications>
</template>

<script setup>
  import { useUserStore } from "@/store/user"
  const loginShowing = ref(false)
  const joinShowing = ref(false)

  const userStore = useUserStore()

  defineProps({
    title: {
      type: String,
      required: true,
    },
  })

  const showJoinModal = () => {
    joinShowing.value = true
  }

  const showLoginModal = () => {
    loginShowing.value = true
  }
</script>
